<mat-checkbox [formControl]="control" id="app-checkbox">{{
  checkboxLabel
}}</mat-checkbox>
